import React from "react";

// bloco branco padrão do painel, com cabeçalho opcional (título, descrição e ações)
export default function AdminCard({
    title,
    description,
    actions,
    children,
    className = "",
    bodyClassName = "p-4 md:p-6",
    header
}: {
    title?: React.ReactNode;
    description?: React.ReactNode;
    actions?: React.ReactNode;
    children?: React.ReactNode;
    className?: string;
    bodyClassName?: string;
    // cabeçalho livre no lugar de título/ações (ex.: abas)
    header?: React.ReactNode;
}) {
    return (
        <section className={`bg-white rounded-xl border border-gray-200 shadow-sm ${className}`}>
            {
                header ?
                    <div className="px-2 md:px-4 border-b border-gray-200">{header}</div>
                    : null
            }
            {
                !header && (title || actions) ?
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 px-4 md:px-6 py-4 border-b border-gray-200">
                        <div className="min-w-0">
                            {
                                title ?
                                    <h2 className="text-base font-bold text-gray-900 flex items-center gap-2 flex-wrap">{title}</h2>
                                    : null
                            }
                            {
                                description ?
                                    <p className="text-sm text-gray-500 mt-0.5">{description}</p>
                                    : null
                            }
                        </div>
                        {
                            actions ?
                                <div className="flex flex-wrap items-center gap-2">{actions}</div>
                                : null
                        }
                    </div>
                    : null
            }
            {
                children ?
                    <div className={bodyClassName}>{children}</div>
                    : null
            }
        </section>
    )
}
